import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/drivewayCost/blog-driveway-cost-001.jpg";
import img002 from "../../images/drivewayCost/blog-driveway-cost-002.jpg";
import img003 from "../../images/drivewayCost/blog-driveway-cost-003.jpg";
import img004 from "../../images/drivewayCost/blog-driveway-cost-004.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const DrivewayCostData = {
  title: "How Much Does Brick Driveway Paving Cost?",
  image: img001,
  destination: "/blog/how-much-does-brick-driveway-paving-cost",
  date: "August 7, 2016",
  categories: ["blog", "driveways", "installation"],
};

const DrivewayCost = () => {
  const blog = [DrivewayCostData];

  return (
    <>
      <SEO
        title="How Much Does Brick Driveway Paving Cost?"
        description="Renovating your old driveway can be one of the best curb appeal investments for your Southern California home. Learn a few main options to consider."
        profileURL={
          "https://www.pacificpavingstone.com/blog/how-much-does-brick-driveway-paving-cost"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/how-much-does-brick-driveway-paving-cost",
          headline: "How Much Does Brick Driveway Paving Cost?",
          description:
            "Renovating your old driveway can be one of the best curb appeal investments for your Southern California home. Learn a few main options to consider.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-driveway-cost-001.28c50851.jpg",
          },
          datePublished: "2016-08-07",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Renovating your old driveway can be one of the best curb appeal
              investments for your Southern California home. As you begin to
              research driveway paving materials, you’ll find a few main options
              to consider.
            </p>
            <p>
              Homeowners in Los Angeles and the surrounding areas are shifting
              from traditional materials to a better driveway material option.
              The old driveway paving materials such as asphalt, clay bricks,
              and poured concrete are being dismissed for a better alternative,
              interlocking paving stones.
            </p>
            <p>
              These manufactured concrete paving stones (or pavers) often get
              the nickname of “bricks” due to the individual stone’s appearance.
            </p>
            <h4>How Much Does Brick Driveway Paving Cost?</h4>
            <div className="row justify-content-center">
              <div className="col-md-5">
                <img src={img002} alt="Feature" />
              </div>
              <div className="col-md-7">
                <p>
                  Pavers are the best choice for your new driveway if you want a
                  versatile and durable material. Overall, costs may be just a
                  small margin higher for materials than out-dated materials
                  such as asphalt and concrete. However, the return on
                  investment you will see in a paving stone driveway makes it
                  the clear winning choice.
                </p>
              </div>
            </div>
            <ul>
              <li>
                <span className="text-blue">Cost Per Square Foot:</span>{" "}
                Calculating brick driveway paving cost depends on a number of
                factors. As with any home improvement material, there are
                premium materials, but a typical cost of this style of driveway
                will run you around $8.50 per sq. ft., including installation.
              </li>
              <li>
                <span className="text-blue">Project Total:</span> The average
                Southern California driveway is approximately 1,000 sq. ft.
                Brick driveway paving cost on a space that size will typically
                come in at around $8,500, with removal of the old driveway, base
                and paving stone installation.
              </li>
              <li>
                <span className="text-blue">Extra Base Material:</span> In some
                rare instances, there may be additional materials needed to give
                a proper base on which to lay your new paving stone driveway. If
                there is an unusually high concentration of clay in the
                underlying soil, brick driveway paving cost may be slightly
                higher. Your driveway paving company can let you know how likely
                this is in your neighborhood and the potential surcharge.
              </li>
              <li>
                <span className="text-blue">Site Grading:</span> For the most
                part, properties are graded properly when originally built.
                However, surroundings occasionally change around your home which
                could have altered the course of runoff. If these conditions
                have changed substantially and water is regularly traveling
                across your driveway, slight improvements in the grade may help
                your new brick driveway paving project to avoid potential
                problems from excessive runoff from a neighboring property. It’s
                not a common extra expense, but one worth discussing with your
                landscape designer.
              </li>
              <li>
                <span className="text-blue">Drains & Pipes:</span> If you’re
                tearing out an old driveway, it is an excellent opportunity to
                re-route existing downspouts to other areas on your property. It
                may make sense to run these lines underneath your new driveway.
                This may slightly increase brick driveway paving costs, but it
                can be a terrific time to improve your Southern California
                property.
              </li>
              <li>
                <span className="text-blue">Paving Stone Walkways:</span> If
                you’re taking the time to renovate an old driveway, it may be an
                excellent time to also tear out the boring poured concrete
                walkway leading to your front door or backyard. Adding a
                matching paving stone walkway will increase your brick driveway
                paving cost but combining the two projects could save you money
                versus performing them in stages.
              </li>
              <li>
                <span className="text-blue">Plantings:</span> If your driveway
                paving company also provides a full array of landscape design
                services, you may want to also address some nearby plantings.
                Occasionally, there are existing trees or shrubs that may have
                been encroaching on paved areas or blocking views while backing
                out onto the street. A full-service contractor can help you find
                suitable replacement plants if needed. This could increase your
                brick driveway paving cost, but could also be the best and most
                cost-effective time to address these improvements.
              </li>
            </ul>

            <h4>Brick Driveway Paving Companies in Southern California</h4>
            <div className="row justify-content-center">
              <div className="col-md-5">
                <img src={img003} alt="Feature" />
              </div>
              <div className="col-md-7">
                <p>
                  Brick driveway paving is an important investment. It can be
                  easy to find dozens of companies in Los Angeles and
                  surrounding areas that install driveways. Be sure that you
                  spend some time researching the company and their work.
                </p>
                <p>
                  Brick driveway paving cost is impacted by the materials used,
                  compensation of the labor, and the overhead costs of the
                  company. Be careful to not just go with the lowest price.
                  Contractors can install a driveway cheaper if they cut
                  corners, used inexperienced installers, or don’t carry
                  essential insurances and licenses.
                </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-5">
                <img src={img004} alt="Feature" />
              </div>
              <div className="col-md-7">
                <p>
                  You can rest assured that when you deal with Pacific
                  Pavingstone, we will use the best materials available and
                  install them according to industry standards. Our{" "}
                  <a
                    href="https://www.icpi.org/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ICPI
                  </a>
                  Certified in-house designers and installers have installed
                  tens of thousands of driveways. Our goal is to design a
                  gorgeous driveway at a fair price.
                </p>
                <p>
                  Whether it’s just a new driveway or you have other additions
                  like those mentioned above, we can help. If you’d like to talk
                  more, we’d like to provide you with a free estimate for brick
                  driveway paving cost.{" "}
                  <Link to="/contact-us">
                    Give us a call or fill out the form and someone will be in
                    touch soon!
                  </Link>
                </p>
              </div>
            </div>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(DrivewayCost);
